export const report = {
    labels: {},
    modal: {
        titles: {
        },
        messages: {
        },
    },
    texts: {
        evaluation_empty: "You haven't linked an <strong>EVALUATION</strong> to the report yet!",
    },
};
